import { atom } from 'jotai';
// eslint-disable-next-line import/no-cycle
import { PathsWithBoatType } from './navigation';

interface PathsAtomType {
  [key: string]: PathsWithBoatType;
}

export const reviewSectionBlwAtom = atom<boolean>(false);
export const boatPathsAtom = atom<PathsAtomType>({});
